import { SocialServiceIndividualPlanWidgetStore } from './social-service-individual-plan-widget.store';
import { fb } from '../../../../../../../packages/client/src/app/modules/shared/shared.global-service';
import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TableComponent } from '../../../modules/shared/components/kit/table/table.component';
import { TableColumn, TableColumnType } from '../../../modules/shared/components/kit/table/table.types';
import { folderPersonColumn, userChipColumn } from '../../../modules/shared/components/kit/table/table.fields';
import { getIndividualPlansFrag } from './social-service-individual-plan-widget.query';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import {
    FolderIndividualPlanRevisionsInput,
} from '@libs/types/src/services/input-type/folder/folder-individual-plan.revisions-input';
import { LocalDatePipe } from '../../../modules/shared/pipes/local-date.pipe';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import {
    IndividualPlanDeadlineTypeEnum,
} from '@libs/types/src/services/enum/folder/individual-plan-deadline-type.enum';
import { featureOn } from '../../../feature-flag';

@Component({
    selector: 'app-social-service-individual-plan-widget',
    templateUrl: './social-service-individual-plan-widget.component.html',
    styleUrl: './social-service-individual-plan-widget.component.scss',
    standalone: true,
    providers: [SocialServiceIndividualPlanWidgetStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TableComponent,
        LocalDatePipe,
        PrimeTemplate,
    ],
})
export class SocialServiceIndividualPlanWidgetComponent {

    public readonly store = inject(SocialServiceIndividualPlanWidgetStore);

    public items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected form = fb.group({});

    protected columns: TableColumn[] = [
        {
            ...folderPersonColumn,
            name: 'folderId',
            dataKey: 'folder.person',
            sortable: false,
            filterable: false,
        },
        {
            ...userChipColumn,
            name: 'revisionUserId',
            dataKey: 'revisionUser',
            sortable: false,
            filterable: false,
        },
        {
            name: 'deadlineDate',
            sortable: false,
            filterable: false,
        },
        {
            name: 'deadlineType',
            type: TableColumnType.Tag,
            sortable: false,
            filterable: false,
            tagOptions: {
                labelPrefix: 'individualPlan.deadlineType.',
            },
            severity: (value: unknown) => {
                if (value === IndividualPlanDeadlineTypeEnum.REVISION) return 'info';
                if (value === IndividualPlanDeadlineTypeEnum.REVISION_AND_CONTRACT_END) return 'danger';
                return 'warn';
            },
        },
    ];

    constructor() {
        effect(() => {
            const input = this.items().map((it) => {
                return <FolderIndividualPlanRevisionsInput>{
                    serviceId: Number(it.serviceId),
                    days: it.widget.days,
                    includeContractEnd: featureOn.SOCIAL_SERVICE_DASHBOARD,
                };
            });

            if (featureOn.SOCIAL_SERVICE_DASHBOARD) {
                this.store.api.getIndividualPlanDashboardRevisions(input, getIndividualPlansFrag);
            } else {
                this.store.api.getIndividualPlanRevisions(input, getIndividualPlansFrag);
            }
        });
    }

}
